import { motion } from "framer-motion";

function Hero() {
  return (
    <section id="home" className="min-h-screen relative bg-black text-white flex items-center px-4 md:px-24 overflow-hidden pt-24 md:pt-0">

      {/*  Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-60"
      >
        <source src="/assests/background.mp4" type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col md:flex-row items-center w-full">

        {/* LEFT TEXT (Bottom → Up) */}
        <motion.div
          className="flex-1 text-center md:text-left"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >

          <h1 className="text-3xl sm:text-4xl md:text-7xl font-bold leading-tight">
            Print Your Files <br />
            <span className="text-green-400">Instantly</span> with QR Scan
          </h1>

          <p className="mt-4 md:mt-6 text-sm sm:text-base md:text-xl text-gray-300 max-w-xl mx-auto md:mx-0">
            Scan the QR, upload your file, and get instant prints —
            no OTP, no waiting.
          </p>

          <button onClick={() => window.open("https://app.printezz.com/", "_blank")} className="mt-6 md:mt-10 px-6 md:px-10 py-3 md:py-4 text-sm md:text-lg border border-green-400 text-green-400 
          hover:bg-green-400 hover:text-black transition">
            Start Printing Now →
          </button>

          <div className="mt-6 md:mt-8">
            <p className="text-base md:text-xl font-semibold">
              Scan • Upload • Print
            </p>
            <p className="text-gray-400 mt-1 md:mt-2 text-sm md:text-lg">
              Fast • Secure • No Signup Required
            </p>
          </div>

        </motion.div>

        {/* RIGHT IMAGE (Top → Down) */}
        <motion.div
          className="flex-1 flex justify-center items-center mt-10 md:mt-0 relative"
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >

          {/* Glow */}
          <div className="absolute w-[200px] h-[200px] md:w-[400px] md:h-[400px] bg-green-400/10 blur-2xl rounded-full"></div>

          <img
            src="/assests/home.png"
            alt="printing"
            className="w-[320px] sm:w-[380px] md:w-[850px] lg:w-[980px]
object-contain
relative z-10
scale-110 md:scale-100
drop-shadow-[0_0_25px_rgba(0,255,159,0.3)]
transition duration-500 hover:scale-110 md:hover:scale-125 animate-float "
          />

        </motion.div>

      </div>

    </section>
  );
}

export default Hero;